import { v4 as uuid } from 'uuid'
import { firestore } from 'firebase'

export class Auction {
  constructor(
    title,
    description,
    type,
    activityField,
    status,
    ownerId,
    invitedUsers = [],
  ) {
    this.id = uuid()
    this.title = title
    this.description = description
    this.type = type
    this.activityField = activityField
    this.status = status
    this.ownerId = ownerId
    this.createdAt = firestore.Timestamp.now()
    this.invitedUsers = invitedUsers
  }

  toString() {
    return `${this.title}\n${this.description}\n${this.type}\n${this.activityField}`
  }
}

// Firestore data converter
export const auctionConverter = {
  toFirestore(auction) {
    return {
      id: auction.id,
      title: auction.title,
      description: auction.description,
      type: auction.type,
      activityField: auction.activityField,
      status: auction.status,
      ownerId: auction.ownerId,
      createdAt: auction.createdAt,
      invitedUsers: auction.invitedUsers,
    }
  },
  fromFirestore(snapshot, options) {
    const data = snapshot.data(options)
    return new Auction(
      data.id,
      data.title,
      data.description,
      data.type,
      data.activityField,
      data.status,
      data.ownerId,
      data.createdAt,
      data.invitedUsers,
    )
  },
}

export default Auction
